import { Grid, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { formatScheduledPhaseWallRange } from "../utils/eventWallTime";
import arrowElbowDownRightIcon from "../assets/reviewIcons/arrow-elbow-down-right.svg";

type ScheduledBudgetPhaseDisplaySegment = {
  time_start?: string;
  time_end?: string;
  amount?: {
    amount?: number | string | null;
    currency?: string | null;
  } | null;
};

export type ScheduledBudgetPhaseRowsProps = {
  segments: ScheduledBudgetPhaseDisplaySegment[];
  eventTimezone: string;
  labelMinW?: string;
  opacity?: number;
  amountUnit?: "major" | "minor";
};

export function ScheduledBudgetPhaseRows({
  segments,
  eventTimezone,
  labelMinW = "120px",
  opacity = 0.75,
  amountUnit = "major",
}: ScheduledBudgetPhaseRowsProps) {
  return (
    <VStack align="stretch" spacing={1.5}>
      {segments.map((seg, phaseIndex) => {
        const raw = seg.amount?.amount;
        const parsedAmount = raw != null ? Number(raw) : Number.NaN;
        const amount =
          Number.isFinite(parsedAmount) && amountUnit === "minor"
            ? parsedAmount / 100
            : parsedAmount;
        const currency = seg.amount?.currency ?? "USD";
        const symbol = currency === "USD" ? "$" : `${currency} `;
        const amountLabel =
          Number.isFinite(amount) && amount > 0
            ? `${symbol}${Math.round(amount)}`
            : "—";
        const rangeLabel = formatScheduledPhaseWallRange(
          seg.time_start ?? "",
          seg.time_end ?? "",
          eventTimezone,
          { phaseIndex, totalPhases: segments.length }
        );
        return (
          <Grid
            key={`phase-${phaseIndex}`}
            w="full"
            templateColumns={`${labelMinW} 42px minmax(0, 1fr)`}
            columnGap={1}
            alignItems="center"
            opacity={opacity}
          >
            <HStack minW={labelMinW} spacing={1.5} align="center">
              <Image
                src={arrowElbowDownRightIcon}
                alt=""
                boxSize={6}
                flexShrink={0}
              />
              <Text fontSize="sm" fontWeight="medium" color="gray.600">
                {`Phase ${phaseIndex + 1}`}
              </Text>
            </HStack>
            <Text
              fontSize="sm"
              fontWeight="medium"
              color="gray.600"
              sx={{ fontVariantNumeric: "tabular-nums" }}
            >
              {amountLabel}
            </Text>
            <Text
              minW={0}
              fontSize="sm"
              fontWeight="medium"
              color="gray.600"
              noOfLines={2}
            >
              {rangeLabel}
            </Text>
          </Grid>
        );
      })}
    </VStack>
  );
}
